type BackgroundColor = string | string[] | undefined;

const TRANSPARENT_BACKGROUND = 'transparent';

export function toLinearGradient(backgroundColor: BackgroundColor, side: 'left' | 'right'): string | string[] {
	if (backgroundColor === undefined || backgroundColor === TRANSPARENT_BACKGROUND) return TRANSPARENT_BACKGROUND;

	if (Array.isArray(backgroundColor)) {
		return backgroundColor.map((color) =>
			color === TRANSPARENT_BACKGROUND ? 'transparent' : `linear-gradient(to ${side}, transparent, ${color} 90%)`,
		);
	}
	return `linear-gradient(to ${side}, transparent, ${backgroundColor} 90%)`;
}
